import { Space } from "~/lib/types";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { SpaceAdvisoryPage } from "~/pages/space/SpaceAdvisory/SpaceAdvisory";

interface AdvisoryEntryPageProps {
  space: Space;
  scope: SpaceOrWorkspaceScope;
}

const AdvisoryEntryPage = ({ space, scope }: AdvisoryEntryPageProps) => {
  return <SpaceAdvisoryPage space={space} scope={scope} />;
};

export default AdvisoryEntryPage;
